__turbopack_context__.v({
  "closeBtn": "PdfViewerButton-module-scss-module__1Qnlqa__closeBtn",
  "modal": "PdfViewerButton-module-scss-module__1Qnlqa__modal",
  "overlay": "PdfViewerButton-module-scss-module__1Qnlqa__overlay",
});
